import { Box, BoxProps } from '@chakra-ui/react'
import React from 'react'

export interface DefintionValueProps extends BoxProps {
  children: JSX.Element | JSX.Element[] | string | number
}

const DefintionValue = ({
  children,
  width = '50%',
  ...baseProps
}: DefintionValueProps) => {
  return (
    <Box as="dd" width={width} {...baseProps}>
      {children}
    </Box>
  )
}

export default DefintionValue
